import React from "react";
import Header from "../../components/Header";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import {
  ERROR_HELPERTEXT_STYLES,
  FIELD_ERROR_TEXT,
  upperCaseEmailRegex,
} from "../../utils";
import TextField from "../../components/TextField";
import canadaFlag from "../../assets/CanadaFlag.jpg";

const PrimaryContacts = ({
  data,
  setData,
  error,
  handleInputChange,
  handleCheckbox,
}) => {
  return (
    <div>
      <Header text="Points of Contact" />
      <div className="form_container">
        <div className="form_container" style={{ padding: "0" }}>
          <div className="label1">Personal Lines Manager/Lead</div>
          <TextField
            label="First Name"
            handleChange={handleInputChange}
            name="pl_first_name"
            value={data?.pl_first_name}
            required={false}
            error_state={error?.pl_first_name}
            error_text={FIELD_ERROR_TEXT}
          />{" "}
          <TextField
            label="Last Name"
            handleChange={handleInputChange}
            name="pl_last_name"
            value={data?.pl_last_name}
            required={false}
            error_state={error?.pl_last_name}
            error_text={FIELD_ERROR_TEXT}
          />
          <TextField
            label="Title"
            handleChange={handleInputChange}
            name="pl_title"
            value={data?.pl_title}
            required={false}
            error_state={error?.pl_title}
            error_text={FIELD_ERROR_TEXT}
          />
          <TextField
            label="Email"
            handleChange={handleInputChange}
            name="pl_email"
            value={data?.pl_email}
            required={false}
            error_state={
              data?.pl_email ? !upperCaseEmailRegex.test(data?.pl_email) : false
            }
            custom="email"
            // error_text={
            //   data?.pl_email && error?.pl_email
            //     ? "Please enter valid email"
            //     : FIELD_ERROR_TEXT
            // }
          />
          <TextField
            label="Phone"
            handleChange={handleInputChange}
            name="pl_phone"
            value={data?.pl_phone}
            required={false}
            error_state={error?.pl_phone}
            custom="phone"
            error_text={
              data?.pl_phone && error?.pl_phone
                ? "Please enter valid phone"
                : FIELD_ERROR_TEXT
            }
            addonBefore={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: ".875rem",
                  fontWeight: "600",
                }}
              >
                <img
                  style={{ height: "0.75rem", opacity: "0.7" }}
                  src={canadaFlag}
                  alt=""
                />
                <span>+1</span>
              </div>
            }
          />
        </div>
      </div>

      <div className="mb_16"></div>

      {/* <Header text="" /> */}
      <div className="form_container">
        <div className="form_container" style={{ padding: "0" }}>
          {" "}
          <div className="label1">Contract Relationship</div>
          <TextField
            label="First Name"
            handleChange={handleInputChange}
            name="cra_first_name"
            value={data?.cra_first_name}
            required={false}
            error_state={error?.cra_first_name}
            error_text={FIELD_ERROR_TEXT}
          />{" "}
          <TextField
            label="Last Name"
            handleChange={handleInputChange}
            name="cra_last_name"
            value={data?.cra_last_name}
            required={false}
            error_state={error?.cra_last_name}
            error_text={FIELD_ERROR_TEXT}
          />
          <TextField
            label="Title"
            handleChange={handleInputChange}
            name="cra_title"
            value={data?.cra_title}
            required={false}
            error_state={error?.cra_title}
            error_text={FIELD_ERROR_TEXT}
          />
          <TextField
            label="Email"
            handleChange={handleInputChange}
            name="cra_email"
            value={data?.cra_email}
            required={false}
            error_state={
              data?.cra_email
                ? !upperCaseEmailRegex.test(data?.cra_email)
                : false
            }
            custom="email"
            // error_text={
            //   data?.cra_email && error?.cra_email
            //     ? "Please enter valid email"
            //     : FIELD_ERROR_TEXT
            // }
          />
          <TextField
            label="Phone"
            handleChange={handleInputChange}
            name="cra_phone"
            value={data?.cra_phone}
            required={false}
            error_state={error?.cra_phone}
            custom="phone"
            error_text={
              data?.cra_phone && error?.cra_phone
                ? "Please enter valid phone"
                : FIELD_ERROR_TEXT
            }
            addonBefore={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: ".875rem",
                  fontWeight: "600",
                }}
              >
                <img
                  style={{ height: "0.75rem", opacity: "0.7" }}
                  src={canadaFlag}
                  alt=""
                />
                <span>+1</span>
              </div>
            }
          />
        </div>
      </div>

      <div className="mb_16"></div>

      <div className="form_container">
        <div className="form_container" style={{ padding: "0" }}>
          {" "}
          <div className="label1">Accounting</div>
          <TextField
            label="First Name"
            handleChange={handleInputChange}
            name="acc_first_name"
            value={data?.acc_first_name}
            required={false}
            error_state={error?.acc_first_name}
            error_text={FIELD_ERROR_TEXT}
          />{" "}
          <TextField
            label="Last Name"
            handleChange={handleInputChange}
            name="acc_last_name"
            value={data?.acc_last_name}
            required={false}
            error_state={error?.acc_last_name}
            error_text={FIELD_ERROR_TEXT}
          />
          <TextField
            label="Title"
            handleChange={handleInputChange}
            name="acc_title"
            value={data?.acc_title}
            required={false}
            error_state={error?.acc_title}
            error_text={FIELD_ERROR_TEXT}
          />
          <TextField
            label="Email"
            handleChange={handleInputChange}
            name="acc_email"
            value={data?.acc_email}
            required={false}
            error_state={
              data?.acc_email
                ? !upperCaseEmailRegex.test(data?.acc_email)
                : false
            }
            custom="email"
            // error_text={
            //   data?.acc_email && error?.acc_email
            //     ? "Please enter valid email"
            //     : FIELD_ERROR_TEXT
            // }
          />
          <TextField
            label="Phone"
            handleChange={handleInputChange}
            name="acc_phone"
            value={data?.acc_phone}
            required={false}
            error_state={error?.acc_phone}
            custom="phone"
            error_text={
              data?.acc_phone && error?.acc_phone
                ? "Please enter valid phone"
                : FIELD_ERROR_TEXT
            }
            addonBefore={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: ".875rem",
                  fontWeight: "600",
                }}
              >
                <img
                  style={{ height: "0.75rem", opacity: "0.7" }}
                  src={canadaFlag}
                  alt=""
                />
                <span>+1</span>
              </div>
            }
          />
        </div>
      </div>

      <div className="mb_16"></div>

      <div>
        <div className="form_container">
          {" "}
          <div className="label1">Communication</div>
          <TextField
            label="Marketing Email"
            handleChange={handleInputChange}
            name="marketing_email"
            value={data?.marketing_email}
            required={false}
            error_state={
              data?.marketing_email
                ? !upperCaseEmailRegex.test(data?.marketing_email)
                : false
            }
            custom="email"
            // error_text={
            //   data?.marketing_email && error?.marketing_email
            //     ? "Please enter valid email"
            //     : FIELD_ERROR_TEXT
            // }
          />
          <TextField
            label="Product Training Email"
            handleChange={handleInputChange}
            name="product_training_email"
            value={data?.product_training_email}
            required={false}
            error_state={
              data?.product_training_email
                ? !upperCaseEmailRegex.test(data?.product_training_email)
                : false
            }
            custom="email"
            // error_text={
            //   data?.product_training_email && error?.product_training_email
            //     ? "Please enter valid email"
            //     : FIELD_ERROR_TEXT
            // }
          />
          <div>
            <div
              className="label1"
              style={{ marginBottom: "0", marginTop: ".5rem" }}
            >
              Canada’s Anti-Spam Law (CASL) requires consent for our electronic
              messages.
            </div>
            <FormGroup>
              <FormControlLabel
                sx={{
                  "&.MuiFormControlLabel-root": {
                    padding: ".5rem 0 0",
                    borderRadius: "5px",
                  },

                  ".MuiTypography-root": {
                    fontFamily: "Montserrat",
                    fontSize: "0.95rem",
                  },
                }}
                required={false}
                control={
                  <Checkbox
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    size="small"
                    sx={{
                      "&.Mui-checked": {
                        color: "#8ed1fc",
                      },
                      color: "#d9d9d9",
                    }}
                    name="consent_forward"
                    checked={data?.consent_forward}
                    onChange={handleCheckbox}
                  />
                }
                label="I consent to RecProtect sending emails to my Brokerage."
              />
            </FormGroup>

            {error?.consent_forward ? (
              <FormHelperText sx={ERROR_HELPERTEXT_STYLES}>
                {FIELD_ERROR_TEXT}
              </FormHelperText>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimaryContacts;
